/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useState, useRef, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Pagination from "@mui/material/Pagination";
import { Icon, Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import CloudDownload from "@mui/icons-material/CloudDownload";
import { withTranslation } from "react-i18next";
import classes from "./subscriptions.module.css";

import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Tooltip from "@mui/material/Tooltip";
import Collapse from "@mui/material/Collapse";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import BlockIcon from "@mui/icons-material/Block";
import RestoreIcon from "@mui/icons-material/Restore";

import UpdateDialog from "./updateDialog";
import CancelDialog from "./cancelDialog";
import SuspendDialog from "./suspendDialog";
import ResumeDialog from "./resumeDialog";
import ChangeDialog from "./changeDialog";
import AddonDialog from "./addonDialog";

import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import actionTypes from "../../../store/actions";
import { connect } from "react-redux";
import Loader from "../../../component/loader";
import SwapHorizontalCircleIcon from "@mui/icons-material/SwapHorizontalCircle";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import Draggable from "react-draggable";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../../../component/button";
import ManageCustomersHierarchy from "../manageCustomers/manageCustomersHierarchy";
import CustomerDetails from "../checkout/customerDetails/customerDetails";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";
import {
  DeleteIconNew,
  EditIconNew,
  ShiftIcon,
  SuspendIcon,
  ResumeIcon,
  ViewIcon,
  ViewIconNew,
  PlusIcon,
} from "../../../component/icons/icons.js";
import Input from "../../../component/inputpm";
import {
  SearchIcon,
  ClearIcon,
  EnterArrow,
  AdvanceSearchIcon,
} from "../../../component/icons/icons";
import Box from "@mui/material/Box";
import TableContainer from "@mui/material/TableContainer";
import { useMediaQuery } from "@mui/material";
import dateFormat from "dateformat";
import DraggableResizablePaper from "../../../component/resizablePaper/resizablePaper";
import formatDate from "../../../helper/dateFormatter";
// import { makeStyles } from '@mui/styles';

const SubscriptionsTable = (props) => {
  const [searchIdentifiers, setSearchIdentifiers] = useState({});
  const [showSearchIdentifierFields, setShowSearchIdentifierFields] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");
  // const useStyles = makeStyles({
  //     resizablePaper: {
  //         resize: 'both',
  //         overflow: 'auto',
  //         minWidth: 640,
  //         minHeight: 200,
  //         maxWidth: '90vw',
  //         maxHeight: '90vh',
  //         width: '60vw',
  //     }
  // });
  // const classess = useStyles();

  const t = props.t;
  const mainStyle = {
    maxWidth: "auto",
    margin: "auto",
    padding: "auto",
    paddingTop: "0",
    paddingRight: "0",
    backgroundColor: "transparent",
  };

  const isSuspendable = (item) => {
    for (var i = 0; i < item.length; i++) {
      if (item[i].namedType === "suspendable") {
        return true;
      }
    }
  };

  const hasActivationParms = (item) => {
    for (var i = 0; i < item.length; i++) {
      if (item[i].namedType === "params" && item[i].namedId !== "[]") {
        return true;
      }
    }
  };

  const [loading, setLoading] = useState(false);

  const [cancelData, setCancelData] = useState({
    open: false,
    id: "",
    type: "",
  });
  const openCancelDialog = (id, type) => {
    setCancelData({
      open: true,
      id: id,
      type: type ? type : false,
    });
  };
  const closeCancelDialog = (val) => {
    if (val) {
      setLoading(true);
      BusApiCall(
        "DELETE",
        `${constants.busV4Url}/subscriptions/${cancelData.id}`,
      )
        .then((res) => {
          resetCancelDialog();
          if (res.data && res.data.message) {
            props.setErrorMessage(res.data.message, true);
          } else {
            props.setErrorMessage(
              props.t("SUBSCRIPTION_CANCELLED_SUCCESSFULLY"),
              true,
            );
          }
          setLoading(false);
          let data = {
            partyId: props.isChild
              ? props.childItemDetails.partyId
              : props.customerDetails.partyId,
          };
          props.getCustomerSubscriptions(data);
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            props.setErrorMessage(err.response.data.message, false);
          } else {
            props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
          }
          resetCancelDialog();
          setLoading(false);
        });
    } else {
      resetCancelDialog();
    }
  };

  const resetCancelDialog = () => {
    setCancelData({
      open: false,
      id: "",
    });
  };

  const [changeData, setChangeData] = useState({
    open: false,
    item: {},
  });
  const [addonData, setAddonData] = useState({
    open: false,
    item: {},
  });

  const openChangeDialog = (item) => {
    setChangeData({
      open: true,
      item: item,
    });
  };
  const closeChangeDialog = (val) => {
    if (val) {
      requestChangeSubscription(changeData.item);
    } else {
      resetChangeDialog();
    }
  };

  const resetChangeDialog = () => {
    setChangeData({
      open: false,
      item: {},
    });
  };
  const openAddAddonDialog = (item) => {
    setAddonData({
      open: true,
      item: item,
    });
  };
  const closeAddAddonDialog = (val) => {
    if (val) {
      requestAddAddon(addonData.item);
    } else {
      resetAddAddonDialog();
    }
  };
  const resetAddAddonDialog = () => {
    setAddonData({
      open: false,
      item: {},
    });
  };
  const [suspendData, setSuspendData] = useState({
    open: false,
    id: "",
    action: "",
  });
  const openSuspendDialog = (id, action) => {
    setSuspendData({
      open: true,
      id: id,
      action: action,
      months: action === "SUSPEND" ? "1" : null,
    });
  };
  const onChangeMonths = (e) => {
    setSuspendData({
      ...suspendData,
      months: e.target.value,
    });
  };
  const closeSuspendDialog = (val) => {
    if (val) {
      if (suspendData.action === "CHANGE") {
        // open customer dailog
        setShowCustomerDialog(true);
      } else if (suspendData.action === "SHIFT") {
        resetSuspendDialog();
        setLoading(true);
        var paylod = {};
        BusApiCall(
          "PUT",
          `${constants.busV44UrlPublic}/subscriptions/${suspendData.id}/type/ShiftSubscription`,
          paylod,
        )
          .then((res) => {
            if (res.data && res.data.message) {
              props.setErrorMessage(res.data.message, true);
            } else {
              props.setErrorMessage(
                props.t("SHIFT_SUBSCRIPTION_SUCCESSFULLY"),
                true,
              );
            }
            resetSuspendDialog();
            setLoading(false);
            let data = {
              partyId: props.isChild
                ? props.childItemDetails.partyId
                : props.customerDetails.partyId,
            };
            props.getCustomerSubscriptions(data);
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              props.setErrorMessage(err.response.data.message, false);
            } else {
              props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
            }
            setLoading(false);
          });
      } else {
        setLoading(true);
        let data = { action: suspendData.action };
        if (suspendData.action === "SUSPEND") {
          data.duration = Number(suspendData.months);
          data.isDunning = false;
        }
        if (suspendData.action === "RESUME") {
          data.isDunning = false;
        }
        BusApiCall(
          "PUT",
          `${constants.busV4Url}/subscriptions/${suspendData.id}`,
          data,
        )
          .then((res) => {
            props.setErrorMessage(
              props.t("SUBSCRIPTION_UPDATED_SUCCESSFULLY"),
              true,
            );
            setLoading(false);
            resetSuspendDialog();
            let customerData = {
              partyId: props.isChild
                ? props.childItemDetails.partyId
                : props.customerDetails.partyId,
            };
            props.getCustomerSubscriptions(customerData);
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              props.setErrorMessage(err.response.data.message, false);
            } else {
              props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
            }
            resetSuspendDialog();
            setLoading(false);
          });
      }
    } else {
      resetSuspendDialog();
    }
  };
  const resetSuspendDialog = () => {
    setSuspendData({
      open: false,
      id: "",
      action: "",
    });
  };
  const requestChangeSubscription = (item) => {
    var childItemDetails = props.childItemDetails ? props.childItemDetails : {};
    var customer = props.customerDetails;
    var obj = {
      ban: customer.ban,
      partyId:
        childItemDetails && childItemDetails.partyId
          ? childItemDetails.partyId
          : customer.partyId,
      customerId: customer.partyId,
      orderId: item.orderId,
      subscriptionId: item.subscriptionId,
      firstName:
        childItemDetails && childItemDetails.partyId
          ? childItemDetails.firstName
          : customer.firstName,
      lastName:
        childItemDetails && childItemDetails.partyId
          ? childItemDetails.lastName
          : customer.lastName,
      role: customer.role,
      mode: "ChangeSubscription",
      additionalAttributes: item.additionalAttributes,
      productCode: item.productCode,
      productId: item.productId,
      oldQuote: false,
      packageIndex: item.packageIndex,
      nonEditableItem: true,
      productName: item.productName,
      additionalAttributes: item.additionalAttributes,
      orderItemSeqId: item.orderItemSeqId,
    };
    props.changeRoute(obj);
  };
  const requestAddAddon = (item) => {
    var childItemDetails = props.childItemDetails ? props.childItemDetails : {};
    var customer = props.customerDetails;
    var obj = {
      ban: customer.ban,
      partyId:
        childItemDetails && childItemDetails.partyId
          ? childItemDetails.partyId
          : customer.partyId,
      customerId: customer.partyId,
      orderId: item.orderId,
      subscriptionId: item.subscriptionId,
      firstName:
        childItemDetails && childItemDetails.partyId
          ? childItemDetails.firstName
          : customer.firstName,
      lastName:
        childItemDetails && childItemDetails.partyId
          ? childItemDetails.lastName
          : customer.lastName,
      role: customer.role,
      mode: "NewAddon",
      productCode: item.productCode,
      productId: item.productId,
      oldQuote: false,
      packageIndex: item.packageIndex,
      nonEditableItem: true,
      productName: item.productName,
      additionalAttributes: item.additionalAttributes,
      orderItemSeqId: item.orderItemSeqId,
    };
    props.changeRoute(obj);
  };
  const [updateData, setUpdateData] = useState({
    id: "",
    variants: [],
    open: false,
  });
  const openUpdateComponentDialog = (id, variants) => {
    setUpdateData({
      id: id,
      variants: variants,
      open: true,
    });
  };
  const closeUpdateDialog = (val, newPlan) => {
    if (val) {
      setLoading(true);
      let data = { targetPlanId: newPlan };
      BusApiCall(
        "PUT",
        `${constants.busV4Url}/subscriptions/${updateData.id}`,
        data,
      )
        .then((res) => {
          props.setErrorMessage(props.t("UPDATE_SUBSCRIPTION_CREATED"), true);
          setLoading(false);
          resetUpdateData();
          let customerData = {
            partyId: props.isChild
              ? props.childItemDetails.partyId
              : props.customerDetails.partyId,
          };
          props.getCustomerSubscriptions(customerData);
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            props.setErrorMessage(err.response.data.message, false);
          } else {
            props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
          }
          setLoading(false);
          resetUpdateData();
        });
    } else {
      resetUpdateData();
    }
  };
  const resetUpdateData = () => {
    setUpdateData({
      id: "",
      variants: [],
      open: false,
    });
  };

  const [showCustomerDialog, setShowCustomerDialog] = useState(false);
  const [selectedTreeItems, changeSelectedTreeItems] = useState([]);
  const [customerDetails, setCustomerDetails] = useState({});
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);

  const selectCustomerClose = (
    currStage,
    data,
    selectedTreeItems,
    selectedPaymentMethod,
  ) => {
    setLoading(true);
    var subscriptionData = { ...suspendData };
    // setCustomerDetails(data);
    // changeSelectedTreeItems(selectedPaymentMethod);
    resetSuspendDialog();
    setShowCustomerDialog(false);
    var paylod = {
      partyId: data.partyId,
      customerId: data.ban,
    };
    BusApiCall(
      "PUT",
      `${constants.busV44UrlPublic}/subscriptions/${subscriptionData.id}/type/TakeoverSubscription`,
      paylod,
    )
      .then((res) => {
        if (res.data && res.data.message) {
          props.setErrorMessage(res.data.message, true);
        } else {
          props.setErrorMessage(
            props.t("TAKEOVER_SUBSCRIPTION_SUCCESSFULLY"),
            true,
          );
        }
        setLoading(false);
        let data = {
          partyId: props.isChild
            ? props.childItemDetails.partyId
            : props.customerDetails.partyId,
        };
        props.getCustomerSubscriptions(data);
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          props.setErrorMessage(err.response.data.message, false);
        } else {
          props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
        }
        setLoading(false);
      });
  };
  const closeDialog = () => {
    console.log("close dialog normally");
    resetSuspendDialog();
    setShowCustomerDialog(false);
    setCustomerDetails({});
    setSelectedPaymentMethod(null);
  };
  const resetSelecteddata = () => {
    console.log("reset selected data executed");
  };

  const [showNewCustomer, setShowNewCustomer] = useState(false);
  const [newCustomerDetails, setNewCustomerDetails] = useState({});

  const removeCustomerForm = () => {
    setShowNewCustomer(false);
    setShowCustomerDialog(true);
  };

  const closeErrorMessage = (error, type) => {
    props.setErrorMessage(error, type);
  };

  // This function is used to check new/update customer data
  const addCustomer = (data) => {
    setLoading(true);
    let contact = {
      ...data,
    };
    delete contact.billing;
    delete contact.shipping;
    delete contact.paymentInstrumentsMap;
    delete contact.paymentMethod;
    let banDetails = {
      accountName: data.accountName,
      ban: data.ban,
      partyId: data.partyId,
      label: data.label,
      value: data.ban,
    };
    let newData = {
      banDetails: banDetails,
      contact: contact,
      billing: data.billing,
      shipping: data.shipping,
      // paymentInstrumentsMap: data.paymentInstrumentsMap ? data.paymentInstrumentsMap : null
      paymentInstrumentsMap: null,
    };
    BusApiCall("POST", `${constants.busInternalUrl}/customers`, newData)
      .then((res) => {
        var tempData = {
          partyId: res.data.customer.partyId,
          ban: data.ban,
        };
        selectCustomerClose(null, tempData);
        setNewCustomerDetails({});
        setShowNewCustomer(false);
        // setLoading(false);
        var customer = {
          accountName: newData.banDetails.accountName,
        };
        props.setErrorMessage(
          this.props.t("CUSTOMER_CREATED_SUCCESSFULLY", { customer }),
          true,
        );
        if (data.paymentInstrumentsMap) {
          let paymentData = {
            contact: {
              firstName: newData.contact.firstName,
              lastName: newData.contact.lastName,
              partyId: res.data.customer.partyId,
              officePhone: newData.contact.officePhone,
              mobilePhone: newData.contact.mobilePhone,
              email: newData.contact.email,
              emailMechId: res.data.customer.emailMechId,
              mobilePhoneMechId: res.data.customer.mobilePhoneMechId,
              officePhoneMechId: res.data.customer.officePhoneMechId,
              billingCloseDay: newData.contact.billingCloseDay,
            },
            billing: {
              attention: "",
              phone: "",
              street1: "",
              street2: "",
              city: "",
              state: "",
              zip: "",
              country: "",
            },
            shipping: {
              attention: "",
              phone: "",
              street1: "",
              street2: "",
              city: "",
              state: "",
              zip: "",
              country: "",
            },
            banDetails: {
              accountName: data.accountName,
              ban: data.ban,
            },
          };
          if (data.paymentInstrumentsMap.creditCard) {
            let cardData = data.paymentInstrumentsMap.creditCard;
            let creditCard = {
              cardType: cardData.cardType,
              isPrimary: cardData.isPrimary,
              cardNumber: cardData.cardNumber,
              expireDate: cardData.expireDate,
              nameOnCard:
                cardData.firstNameOnCard + " " + cardData.lastNameOnCard,
              ...data.billing,
              billingContactMechId: res.data.customer.billing.postalMechId,
            };
            let payment = {
              creditCard: creditCard,
            };
            paymentData.paymentInstrumentsMap = payment;
          } else if (data.paymentInstrumentsMap.eftAccount) {
            let eftAccount = {
              ...data.paymentInstrumentsMap.eftAccount,
              ...data.billing,
              billingContactMechId: res.data.customer.billing.postalMechId,
            };
            let payment = {
              eftAccount: eftAccount,
            };
            paymentData.paymentInstrumentsMap = payment;
          }
          BusApiCall(
            "POST",
            `${constants.busInternalUrl}/customers`,
            paymentData,
          ).then((paymentRes) => {
            // props.setErrorMessage(props.t('CUSTOMER_CREATED_SUCCESSFULLY', { customer }), true);
          });
          // .catch(err => {
          //     if (err.response && err.response.data && err.response.data.message) {
          //         props.setErrorMessage(err.response.data.message, false)
          //     } else {
          //         props.setErrorMessage(this.props.t('DEFAULT_ERROR_MESSAGE'), false)
          //     }
          //     setLoading(false);
          // })
        }
      })
      .catch((err) => {
        setNewCustomerDetails({});
        setShowNewCustomer(false);
        if (err.response && err.response.data && err.response.data.message) {
          props.setErrorMessage(err.response.data.message, false);
        } else {
          props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
        }
        setLoading(true);
      });
  };

  const getSearchIdentifiers = () => {
    let data = {};
    console.log("props.providerType", props.providerType, "props.tenantId", props.tenantId);
    if (props.providerType === "SOLUTION_PROVIDER") {
      data = {
        tenantId: props.tenantId,
      };
    }
    BusApiCall('GET', `${constants.busInternalUrl}/passthru/GET_EXTERNAL_IDENTIFIERS/endpoint`, data).then(res => {
      console.log("res", res);
      setSearchIdentifiers(res.data || {});
    }).catch(err => {
      if (err.response && err.response.data && err.response.data.message) {
        props.setErrorMessage(err.response.data.message, false);
      } else {
        props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
      }
      console.log("err", err);
      setSearchIdentifiers([]);
    })
  }

  useEffect(() => {
    getSearchIdentifiers();
  }, []);


  return (
    <div style={{ width: "-webkit-fill-available" }}>
      <div>
        <Grid container spacing={4}>
          <Grid
            item
            size={{
              xs: 12,
            }}
          >
            <h3
              style={{
                marginTop: "2rem",
                marginBottom: "1rem",
                paddingLeft: "1rem",
              }}
            >
              {t("SUBSCRIPTIONS")}:{" "}
              {props.isChild
                ? props.childItemDetails.accountName
                : props.customerDetails.accountName}
              {/* {t('SUBSCRIPTIONS')}: {props.customerDetails.accountName} */}
            </h3>
            {/* <Paper elevation={0}> */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingLeft: "1rem",
                paddingRight: "1rem",
              }}
            >
              <div
                className={classes.searchOuterDiv}
                style={{ marginBottom: ".5rem" }}
              >
                <div className={classes.searchInputDiv}>
                  <Input
                    size={"small"}
                    variant={"outlined"}
                    placeholder={t("SUBSCRIPTION_NAME")}
                    value={props.subsFilters.productName}
                    name={"productName"}
                    onChange={(e) => {
                      props.onChangeSubsInput(e);
                    }}
                    divClass={classes.inputClass}
                    onKeyDown={(e) => {
                      props.onSearchKeyDownSubsInput(e);
                    }}
                  />
                </div>
                <div className={classes.searchInputDiv}>
                  <Input
                    size={"small"}
                    variant={"outlined"}
                    placeholder={t("SUBSCRIPTION_ID")}
                    value={props.subsFilters.subscriptionId}
                    name={"subscriptionId"}
                    onChange={(e) => {
                      props.onChangeSubsInput(e);
                    }}
                    divClass={classes.inputClass}
                    onKeyDown={(e) => {
                      props.onSearchKeyDownSubsInput(e);
                    }}
                  />
                </div>
                <div className={classes.searchInputDiv}>
                  <Input
                    size={"small"}
                    variant={"outlined"}
                    placeholder={t("ORDER_ID")}
                    value={props.subsFilters.orderId}
                    name={"orderId"}
                    onChange={(e) => {
                      props.onChangeSubsInput(e);
                    }}
                    divClass={classes.inputClass}
                    onKeyDown={(e) => {
                      props.onSearchKeyDownSubsInput(e);
                    }}
                  />
                </div>
                {/* <div className={classes.searchOrderLabelOuter}>
                                    <div className={classes.searchOrderLabelInner}> */}
                <div style={{ display: "flex", alignItems: "flex-start", gap: "0.5rem" }}>
                  <Tooltip title={t("SEARCH")}>
                    <IconButton
                      className="iconButtonSecondary"
                      onClick={props.filterSubsTable}
                    >
                      <SearchIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={t("CLEAR")}>
                    <IconButton
                      className="iconButtonSecondary"
                      onClick={props.clearSubsTableSearch}
                    >
                      <ClearIcon />
                    </IconButton>
                  </Tooltip>
                  {searchIdentifiers && Object.keys(searchIdentifiers).length > 0 && (
                    <Tooltip title={t('ADVANCE_SEARCH')}>
                      <IconButton className='iconButtonSecondary' onClick={() => setShowSearchIdentifierFields(!showSearchIdentifierFields)}>
                        <AdvanceSearchIcon />
                      </IconButton>
                    </Tooltip>
                  )}

                </div>
                {showSearchIdentifierFields && (
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-end"
                    style={{
                      borderTop: showSearchIdentifierFields
                        ? ".5px solid lightgrey"
                        : "none",
                      marginLeft: 0,
                      marginRight: 0,
                      // marginTop: ".5rem",
                      width: "100%",
                      justifyContent: "flex-end",
                      paddingTop: ".5rem",
                      gap: "1rem",
                    }}
                  >
                    <>
                      {searchIdentifiers &&
                        Object.entries(searchIdentifiers).map(
                          ([key, label]) => (
                            <div key={key}>
                              <Input
                                size="small"
                                variant="outlined"
                                placeholder={label}
                                name={key}
                                value={
                                  Array.isArray(props.searchIdentifierValues)
                                    ? (props.searchIdentifierValues.find(i => i.key === key)?.value || '')
                                    : (props.searchIdentifierValues?.[key] || '')
                                }
                                onChange={(e) =>
                                  props.handleSearchIdentifierChange(e)
                                }
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter') {
                                    props.filterSubsTable();
                                  }
                                }}
                              />
                            </div>
                          )
                        )}
                    </>
                  </Grid>
                )}

                {/* </div> */}
                {/* <div className='cl'></div> */}
              </div>
              <Card className="roundCorners" variant="outlined">
                <TableContainer>
                  <Table className={"subscriptionTable"}>
                    <TableHead>
                      <TableRow style={{ padding: 0 }}>
                        <TableCell style={{ width: "30%" }}>
                          {props.t("SUBSCRIPTION_NAME")}
                        </TableCell>
                        <TableCell>{props.t("SUBSCRIPTION_ID")}</TableCell>
                        <TableCell>{props.t("ORDER_ID")}</TableCell>
                        <TableCell>{props.t("STATUS")}</TableCell>
                        <TableCell style={{ width: "20%" }}>
                          {props.t("ACTION")}
                        </TableCell>
                        {/* <TableCell className={classes.subscriptionCustomTable + ' subscriptionCustomTableHeading'}>
                                            <div style={{ width: '4%' }}>&nbsp;</div>
                                            <div style={{ width: '27%' }} className="global-custom-sorting-header global-div-table-header" onClick={(e) => { props.updateSubsSorting("productName") }}>
                                                <label>{props.t('SUBSCRIPTION_NAME')}</label>
                                                {props.sortBySubs === 'productName' ?
                                                    <span className="material-icons">
                                                        {props.sortOrderSubs === 'DESC' ? 'expand_less' : 'expand_more'}
                                                    </span>
                                                    :
                                                    <span className="material-icons sorting-indicator-icon">
                                                        unfold_more
                                                    </span>
                                                }
                                            </div>
                                            <div style={{ width: '26%' }} className="global-custom-sorting-header global-div-table-header" onClick={(e) => { props.updateSubsSorting("serviceInstanceId") }}>
                                                <label>{props.t('SUBSCRIPTION_ID')}</label>
                                                {props.sortBySubs === 'serviceInstanceId' ?
                                                    <span className="material-icons">
                                                        {props.sortOrderSubs === 'DESC' ? 'expand_less' : 'expand_more'}
                                                    </span>
                                                    :
                                                    <span className="material-icons sorting-indicator-icon">
                                                        unfold_more
                                                    </span>
                                                }
                                            </div>
                                            <div style={{ width: '14%' }} className="global-custom-sorting-header global-div-table-header" onClick={(e) => { props.updateSubsSorting("orderId") }}>
                                                <label>{props.t('ORDER_ID')}</label>
                                                {props.sortBySubs === 'orderId' ?
                                                    <span className="material-icons">
                                                        {props.sortOrderSubs === 'DESC' ? 'expand_less' : 'expand_more'}
                                                    </span>
                                                    :
                                                    <span className="material-icons sorting-indicator-icon">
                                                        unfold_more
                                                    </span>
                                                }
                                            </div>
                                            <div style={{ width: '10%', lineHeight: 2.03 }}>
                                                {props.t('STATUS')}
                                                {/* {props.sortBySubs === 'statusId' ?
                                                    <span className="material-icons">
                                                        {props.sortOrderSubs === 'DESC' ? 'expand_less' : 'expand_more'}
                                                    </span>
                                                    :
                                                    <span className="material-icons sorting-indicator-icon">
                                                        unfold_more
                                                    </span>
                                                } 
                                            </div>
                                            <div style={{ width: '19%', textAlign: 'right', lineHeight: 2.03 }}>
                                                {props.providerType != 'SOLUTION_PROVIDER' &&
                                                    <>{props.t('ACTION')}</>
                                                }
                                            </div>
                                        </TableCell> */}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {props.subscriptions &&
                        props.subscriptions.map((item, index) =>
                          item.productId ? (
                            <>
                              <TableRow
                                key={index}
                                className={"newGlobalTable"}
                              >
                                {/* <TableCell style={{ width: '4%' }}>
                                                        {hasActivationParms(item.additionalAttributes) &&
                                                            <IconButton aria-label="expand row" size="small" onClick={() => props.openSubscription(index)} >
                                                                {item.expand ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                            </IconButton>
                                                        }
                                                    </TableCell> */}
                                {/* <TableCell style={{ maxWidth: isMobile ? 'auto' : '2rem', whiteSpace: 'nowrap' }}>
                                                            <div style={{ display: 'flex' }}>
                                                                <span style={{ marginRight: '.25rem' }}>
                                                                    {item.additionalAttributes && hasActivationParms(item.additionalAttributes) &&
                                                                        <IconButton aria-label="expand row" size="small" onClick={() => props.openSubscription(index)} >
                                                                            {item.expand ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                                        </IconButton>
                                                                    }
                                                                </span>
                                                                <div>{item.productName}</div>
                                                            </div>
                                                        </TableCell> */}
                                <TableCell
                                  style={{
                                    maxWidth: "auto",
                                    //whiteSpace: 'nowrap',
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {/* {item.additionalAttributes && hasActivationParms(item.additionalAttributes) && ( */}
                                    <IconButton
                                      aria-label="expand row"
                                      size="small"
                                      onClick={() =>
                                        props.openSubscription(index)
                                      }
                                      style={{ marginRight: ".25rem" }} // Space between the button and the product name
                                    >
                                      {item.expand ? (
                                        <KeyboardArrowUpIcon />
                                      ) : (
                                        <KeyboardArrowDownIcon />
                                      )}
                                    </IconButton>
                                    {/* )} */}
                                    {item.productName}
                                  </div>
                                </TableCell>
                                {/* <Tooltip title={item.subscriptionId} placement="top" arrow> */}
                                <TableCell
                                  style={{
                                    maxWidth: "auto",
                                    whiteSpace: "nowrap",
                                  }}
                                // className='wordUnbreak'
                                >
                                  {item.subscriptionId}
                                </TableCell>
                                {/* </Tooltip> */}

                                <TableCell>{item.orderId}</TableCell>
                                <TableCell>
                                  <Chip
                                    size="normal"
                                    className={
                                      item.status === "Active"
                                        ? "successChip"
                                        : item.status ===
                                          "Termination in Progress"
                                          ? "errorChip"
                                          : "inProgressChip"
                                    }
                                    label={item.status}
                                  />
                                  {/* {item.status} */}
                                </TableCell>
                                <TableCell>
                                  {props.providerType !=
                                    "SOLUTION_PROVIDER" && (
                                      <>
                                        {item.status.toLowerCase !==
                                          "deactivated" && (
                                            <React.Fragment>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  gap: ".25rem",
                                                }}
                                              >
                                                {item.variants.length > 0
                                                  ? props.userPerms.includes(
                                                    "CUMULATOR_SUBSCRIPTION_UPDATE",
                                                  ) && (
                                                    <Tooltip
                                                      title={props.t(
                                                        "CHANGE_SUBSCRIPTION",
                                                      )}
                                                    >
                                                      <IconButton
                                                        className="buttonSecondary"
                                                        aria-label={props.t(
                                                          "CHANGE_SUBSCRIPTION",
                                                        )}
                                                        style={{
                                                          width: "31.44px",
                                                          height: "31.44px",
                                                        }}
                                                        onClick={() => {
                                                          openUpdateComponentDialog(
                                                            item.subscriptionId,
                                                            item.variants,
                                                          );
                                                        }}
                                                      >
                                                        <EditIconNew />
                                                      </IconButton>
                                                    </Tooltip>
                                                  )
                                                  : item.status === "Active" &&
                                                  props.quoteEnabled &&
                                                  props.userPerms.includes(
                                                    "CUMULATOR_SUBSCRIPTION_UPDATE",
                                                  ) && (
                                                    <Tooltip
                                                      title={props.t(
                                                        "CHANGE_SUBSCRIPTION",
                                                      )}
                                                    >
                                                      <IconButton
                                                        className="buttonSecondary"
                                                        aria-label={props.t(
                                                          "CHANGE_SUBSCRIPTION",
                                                        )}
                                                        style={{
                                                          width: "31.44px",
                                                          height: "31.44px",
                                                        }}
                                                        onClick={() => {
                                                          openChangeDialog(item);
                                                        }}
                                                      >
                                                        <EditIconNew />
                                                      </IconButton>
                                                    </Tooltip>
                                                  )}
                                                {item.status === "Active" &&
                                                  props.quoteEnabled &&
                                                  props.userPerms.includes(
                                                    "CUMULATOR_SUBSCRIPTION_UPDATE",
                                                  ) && (
                                                    <Tooltip
                                                      title={props.t("ADD_ADDONS")}
                                                    >
                                                      <IconButton
                                                        className="buttonSecondary"
                                                        aria-label={props.t(
                                                          "ADD_ADDONS",
                                                        )}
                                                        onClick={() => {
                                                          openAddAddonDialog(item);
                                                        }}
                                                      >
                                                        <PlusIcon />
                                                      </IconButton>
                                                    </Tooltip>
                                                  )}

                                                {/* {item.status === "Active" && props.quoteEnabled && isSuspendable(item.additionalAttributes) &&
                                                                            props.userPerms.includes("CUMULATOR_SUBSCRIPTION_UPDATE") &&
                                                                            <Tooltip
                                                                                title={props.t('TAKEOVER_SUBSCRIPTION')}>
                                                                                <IconButton
                                                                                    aria-label={props.t('TAKEOVER_SUBSCRIPTION')}
                                                                                    onClick={() => {
                                                                                        openSuspendDialog(item.subscriptionId, 'CHANGE')
                                                                                    }}>
                                                                                    <SwapHorizontalCircleIcon
                                                                                        className={classes.tableActionIcons} />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        } */}

                                                {item.status === "Active" &&
                                                  props.quoteEnabled &&
                                                  isSuspendable(
                                                    item.additionalAttributes,
                                                  ) &&
                                                  props.userPerms.includes(
                                                    "CUMULATOR_SUBSCRIPTION_UPDATE",
                                                  ) && (
                                                    <Tooltip
                                                      title={props.t(
                                                        "SHIFT_SUBSCRIPTION",
                                                      )}
                                                    >
                                                      <IconButton
                                                        className="buttonSecondary"
                                                        aria-label={props.t(
                                                          "SHIFT_SUBSCRIPTION",
                                                        )}
                                                        onClick={() => {
                                                          openSuspendDialog(
                                                            item.subscriptionId,
                                                            "SHIFT",
                                                          );
                                                        }}
                                                      >
                                                        <ShiftIcon />
                                                        {/* <ExitToAppIcon
                                                                                        className={classes.tableActionIcons} /> */}
                                                      </IconButton>
                                                    </Tooltip>
                                                  )}

                                                {item.status === "Active" &&
                                                  props.userPerms.includes(
                                                    "CUMULATOR_SUBSCRIPTION_CANCEL",
                                                  ) && (
                                                    <Tooltip
                                                      title={props.t(
                                                        "CANCEL_SUBSCRIPTION",
                                                      )}
                                                    >
                                                      <IconButton
                                                        className="buttonSecondary"
                                                        aria-label={props.t(
                                                          "CANCEL_SUBSCRIPTION",
                                                        )}
                                                        onClick={() => {
                                                          openCancelDialog(
                                                            item.subscriptionId,
                                                            item.isCoreItem,
                                                          );
                                                        }}
                                                      >
                                                        <DeleteIconNew />
                                                      </IconButton>
                                                    </Tooltip>
                                                  )}
                                                {item.status === "Active" &&
                                                  isSuspendable(
                                                    item.additionalAttributes,
                                                  ) &&
                                                  // props.userPerms.includes("CUMULATOR_SUBSCRIPTION_UPDATE") &&
                                                  props.userPerms.includes(
                                                    "CUMULATOR_SUBSCRIPTION_SUSPEND",
                                                  ) && (
                                                    <Tooltip
                                                      title={props.t(
                                                        "SUSPEND_SUBSCRIPTION",
                                                      )}
                                                    >
                                                      <IconButton
                                                        className="buttonSecondary"
                                                        aria-label={props.t(
                                                          "SUSPEND_SUBSCRIPTION",
                                                        )}
                                                        onClick={() => {
                                                          openSuspendDialog(
                                                            item.subscriptionId,
                                                            "SUSPEND",
                                                          );
                                                        }}
                                                      >
                                                        <SuspendIcon />
                                                        {/* <BlockIcon
                                                                                        className={classes.tableActionIcons} /> */}
                                                      </IconButton>
                                                    </Tooltip>
                                                  )}
                                                {item.status === "Suspended" &&
                                                  isSuspendable(
                                                    item.additionalAttributes,
                                                  ) &&
                                                  props.userPerms.includes(
                                                    "CUMULATOR_SUBSCRIPTION_UPDATE",
                                                  ) && (
                                                    <Tooltip
                                                      title={props.t(
                                                        "RESUME_SUBSCRIPTION",
                                                      )}
                                                    >
                                                      <IconButton
                                                        className="buttonSecondary"
                                                        aria-label={props.t(
                                                          "RESUME_SUBSCRIPTION",
                                                        )}
                                                        onClick={() => {
                                                          openSuspendDialog(
                                                            item.subscriptionId,
                                                            "RESUME",
                                                          );
                                                        }}
                                                      >
                                                        <ResumeIcon />
                                                        {/* <RestoreIcon className={classes.tableActionIcons} /> */}
                                                      </IconButton>
                                                    </Tooltip>
                                                  )}
                                                {item.status !== "Active" &&
                                                  item.status !== "Suspended" &&
                                                  item.operationId && (
                                                    <>
                                                      {item.operationType &&
                                                        item.operationType ===
                                                        "order" ? (
                                                        <Tooltip
                                                          title={props.t(
                                                            "VIEW_ORDER",
                                                          )}
                                                        >
                                                          <IconButton
                                                            className="buttonSecondary"
                                                            aria-label={props.t(
                                                              "VIEW_QUOTE",
                                                            )}
                                                            onClick={() => {
                                                              props.goToQuote(
                                                                item.operationId,
                                                                "order",
                                                              );
                                                            }}
                                                          >
                                                            <ViewIconNew />
                                                          </IconButton>
                                                        </Tooltip>
                                                      ) : (
                                                        <Tooltip
                                                          title={props.t(
                                                            "VIEW_QUOTE",
                                                          )}
                                                        >
                                                          <IconButton
                                                            className="buttonSecondary"
                                                            aria-label={props.t(
                                                              "VIEW_QUOTE",
                                                            )}
                                                            onClick={() => {
                                                              props.goToQuote(
                                                                item.operationId,
                                                                "quote",
                                                              );
                                                            }}
                                                          >
                                                            <ViewIconNew />
                                                          </IconButton>
                                                        </Tooltip>
                                                      )}
                                                    </>
                                                  )}
                                              </div>
                                            </React.Fragment>
                                          )}
                                      </>
                                    )}
                                </TableCell>
                                {/* <TableCell style={{ width: '20px', paddingRight: 0 }}>
                                                        {hasActivationParms(item.additionalAttributes) &&
                                                            <IconButton aria-label="expand row" size="small" onClick={() => props.openSubscription(index)} >
                                                                {item.expand ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                            </IconButton>
                                                        }
                                                    </TableCell>
                                                    <TableCell>
                                                        {item.productName}
                                                    </TableCell>
                                                    <TableCell>
                                                        {item.subscriptionId}
                                                    </TableCell>
                                                    <TableCell>
                                                        {item.orderId}
                                                    </TableCell>

                                                    <TableCell align="right">
                                                        {props.providerType != 'SOLUTION_PROVIDER' &&
                                                            <>
                                                                {(item.status).toLowerCase !== "deactivated" &&
                                                                    <React.Fragment>
                                                                        {item.variants.length > 0 ?
                                                                            <Tooltip title={props.t('CHANGE_SUBSCRIPTION')}>
                                                                                <IconButton aria-label={props.t('CHANGE_SUBSCRIPTION')}
                                                                                    onClick={() => { openUpdateComponentDialog(item.subscriptionId, item.variants) }}>
                                                                                    <EditIcon className={classes.tableActionIcons} />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                            :
                                                                            null
                                                                        }
                                                                        <Tooltip title={props.t('CANCEL_SUBSCRIPTION')}>
                                                                            <IconButton aria-label={props.t('CANCEL_SUBSCRIPTION')}
                                                                                onClick={() => { openCancelDialog(item.subscriptionId) }}>
                                                                                <DeleteIcon className={classes.tableActionIcons} />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                        {item.status !== "Suspended" && isSuspendable(item.additionalAttributes) &&
                                                                            <Tooltip title={props.t('SUSPEND_SUBSCRIPTION')}>
                                                                                <IconButton aria-label={props.t('SUSPEND_SUBSCRIPTION')}
                                                                                    onClick={() => { openSuspendDialog(item.subscriptionId, 'SUSPEND') }}>
                                                                                    <BlockIcon className={classes.tableActionIcons} />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        }
                                                                        {item.status === "Suspended" && isSuspendable(item.additionalAttributes) &&
                                                                            <Tooltip title={props.t('RESUME_SUBSCRIPTION')}>
                                                                                <IconButton aria-label={props.t('RESUME_SUBSCRIPTION')}
                                                                                    onClick={() => { openSuspendDialog(item.subscriptionId, 'RESUME') }}
                                                                                >
                                                                                    <RestoreIcon className={classes.tableActionIcons} />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        }
                                                                    </React.Fragment>
                                                                }
                                                            </>
                                                        }
                                                    </TableCell> */}
                              </TableRow>
                              <TableRow>
                                <TableCell
                                  className={
                                    "subscriptionTableCustomeCollapseCell"
                                  }
                                  colSpan={5}
                                  style={{
                                    border: "none",
                                    borderBottom: item.expand
                                      ? "1px solid rgba(224, 224, 224, 1)"
                                      : "none",
                                  }}
                                >
                                  <Collapse
                                    in={item.expand}
                                    timeout="auto"
                                    unmountOnExit
                                  >
                                    <div
                                      style={{
                                        padding: "14px",
                                        paddingLeft: "52px",
                                      }}
                                    >
                                      <Grid
                                        container
                                        spacing={2}
                                        alignItems="stretch"
                                      >
                                        <Grid
                                          item
                                          className={"customerInfoTable"}
                                          size={{
                                            xs: 12,
                                            md: 6,
                                          }}
                                        >
                                          <div style={{ position: "relative" }}>
                                            <h3 style={{ marginTop: 0 }}>
                                              <span
                                                style={{ fontSize: "15px" }}
                                              >
                                                {props.t("CONTRACT_DETAILS")}
                                              </span>
                                            </h3>
                                          </div>
                                          <table
                                            className="customerDetailTabel"
                                            id="contractDetails"
                                          >
                                            {item.addiotinalDetails &&
                                              item.addiotinalDetails
                                                .subscriptionId && (
                                                <tbody>
                                                  {item.addiotinalDetails
                                                    .startDate && (
                                                      <tr>
                                                        <td>{t("START_DATE")}</td>
                                                        <td align="center">:</td>
                                                        <td>
                                                          {formatDate(
                                                            item.addiotinalDetails
                                                              .startDate,
                                                          )}
                                                        </td>
                                                      </tr>
                                                    )}
                                                  {item.addiotinalDetails
                                                    .endDate && (
                                                      <tr>
                                                        <td>{t("END_DATE")}</td>
                                                        <td align="center">:</td>
                                                        <td>
                                                          {formatDate(
                                                            item.addiotinalDetails
                                                              .endDate,
                                                          )}
                                                        </td>
                                                      </tr>
                                                    )}
                                                  <tr>
                                                    <td>
                                                      {t("CONTRACT_PERIOD")}
                                                    </td>
                                                    <td align="center">:</td>
                                                    {item.addiotinalDetails
                                                      .contractPeriod ? (
                                                      <td>
                                                        {
                                                          item.addiotinalDetails
                                                            .contractPeriod
                                                        }
                                                      </td>
                                                    ) : (
                                                      <td>
                                                        {t("NO_COMMITMENT")}
                                                      </td>
                                                    )}
                                                  </tr>
                                                  {item.addiotinalDetails
                                                    .autoRenewable && (
                                                      <tr>
                                                        <td>
                                                          {t("AUTO_RENEWAL")}
                                                        </td>
                                                        <td align="center">:</td>
                                                        <td>
                                                          {item.addiotinalDetails
                                                            .autoRenewable === "Y"
                                                            ? t("YES")
                                                            : t("NO")}
                                                        </td>
                                                      </tr>
                                                    )}
                                                </tbody>
                                              )}
                                          </table>
                                        </Grid>

                                        <Grid
                                          item
                                          className={"customerInfoTable"}
                                          size={{
                                            xs: 12,
                                            md: 6,
                                          }}
                                        >
                                          <div style={{ position: "relative" }}>
                                            <h3 style={{ marginTop: 0 }}>
                                              <span
                                                style={{ fontSize: "15px" }}
                                              >
                                                {props.t("DEVICE_DETAILS")}
                                              </span>
                                            </h3>
                                          </div>
                                          <table
                                            className="customerDetailTabel"
                                            id="deviceDetails"
                                          >
                                            {item.additionalAttributes &&
                                              item.additionalAttributes.map(
                                                (component, c) =>
                                                  component.namedType ===
                                                  "params" && (
                                                    <tbody key={c}>
                                                      {component.namedId &&
                                                        JSON.parse(
                                                          component.namedId,
                                                        ).length > 0 && (
                                                          <>
                                                            {JSON.parse(
                                                              component.namedId,
                                                            ).map(
                                                              (param, p) => (
                                                                <tr key={p}>
                                                                  <td>
                                                                    {
                                                                      param.label
                                                                    }
                                                                  </td>
                                                                  <td align="center">
                                                                    :
                                                                  </td>
                                                                  <td>
                                                                    {
                                                                      param.value
                                                                    }
                                                                  </td>
                                                                </tr>
                                                              ),
                                                            )}
                                                          </>
                                                        )}
                                                      <tr>
                                                        <td colSpan={3}>
                                                          &nbsp;
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  ),
                                              )}
                                          </table>
                                        </Grid>
                                        <Collapse
                                          in={item.expandHistory}
                                          timeout="auto"
                                          unmountOnExit
                                          style={{ width: "100%" }}
                                        >
                                          <Grid
                                            item
                                            size={{
                                              xs: 12,
                                            }}
                                          >
                                            <Table>
                                              <TableRow>
                                                <TableCell
                                                  style={{
                                                    borderBottom: "none",
                                                  }}
                                                >
                                                  {/* <span style={{ display: "flex", alignItems: "center", gap: '1rem', paddingLeft: '40px' }}>
                                                                                                <EnterArrow />
                                                                                                {t('HISTORY')} :
                                                                                            </span> */}
                                                  <div
                                                    style={{
                                                      position: "relative",
                                                    }}
                                                  >
                                                    <h3
                                                      style={{ marginTop: 0 }}
                                                    >
                                                      <span
                                                        style={{
                                                          fontSize: "15px",
                                                        }}
                                                      >
                                                        {props.t("HISTORY")}
                                                      </span>
                                                    </h3>
                                                  </div>
                                                  <div>
                                                    <Card
                                                      className="roundCorners"
                                                      variant="outlined"
                                                    >
                                                      <TableContainer>
                                                        <Table
                                                          className={
                                                            "subscriptionTable"
                                                          }
                                                        >
                                                          <TableHead>
                                                            <TableRow>
                                                              <TableCell>
                                                                {t("DATE")}
                                                              </TableCell>
                                                              <TableCell>
                                                                {t("STATUS")}
                                                              </TableCell>
                                                            </TableRow>
                                                          </TableHead>
                                                          <TableBody>
                                                            {item.addiotinalDetails &&
                                                              item
                                                                .addiotinalDetails
                                                                .history &&
                                                              item
                                                                .addiotinalDetails
                                                                .history
                                                                .length > 0 &&
                                                              item.addiotinalDetails.history.map(
                                                                (
                                                                  historyItem,
                                                                  h,
                                                                ) => (
                                                                  <TableRow
                                                                    key={h}
                                                                  >
                                                                    <TableCell>
                                                                      {formatDate(
                                                                        historyItem.date,
                                                                      )}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                      {/* {historyItem.status} */}
                                                                      <Chip
                                                                        size="normal"
                                                                        className={
                                                                          historyItem.status ===
                                                                            "Active"
                                                                            ? "successChip"
                                                                            : historyItem.status ===
                                                                              "Termination in Progress"
                                                                              ? "errorChip"
                                                                              : "inProgressChip"
                                                                        }
                                                                        label={
                                                                          historyItem.status
                                                                        }
                                                                      />
                                                                    </TableCell>
                                                                  </TableRow>
                                                                ),
                                                              )}
                                                          </TableBody>
                                                        </Table>
                                                      </TableContainer>
                                                    </Card>
                                                  </div>
                                                </TableCell>
                                              </TableRow>
                                            </Table>
                                          </Grid>
                                        </Collapse>
                                      </Grid>
                                      {false && (
                                        <TableContainer>
                                          <Table>
                                            <TableBody>
                                              {item.addiotinalDetails &&
                                                item.addiotinalDetails
                                                  .subscriptionId && (
                                                  <>
                                                    {item.addiotinalDetails
                                                      .startDate && (
                                                        <TableRow>
                                                          <TableCell>
                                                            <span
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                gap: "1rem",
                                                                paddingLeft:
                                                                  "40px",
                                                              }}
                                                            >
                                                              <EnterArrow />
                                                              {t(
                                                                "START_DATE",
                                                              )} :{" "}
                                                              {formatDate(
                                                                item
                                                                  .addiotinalDetails
                                                                  .startDate,
                                                              )}
                                                            </span>
                                                          </TableCell>
                                                        </TableRow>
                                                      )}
                                                    {item.addiotinalDetails
                                                      .endDate && (
                                                        <TableRow>
                                                          <TableCell>
                                                            <span
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                gap: "1rem",
                                                                paddingLeft:
                                                                  "40px",
                                                              }}
                                                            >
                                                              <EnterArrow />
                                                              {t(
                                                                "END_DATE",
                                                              )} :{" "}
                                                              {formatDate(
                                                                item
                                                                  .addiotinalDetails
                                                                  .endDate,
                                                              )}
                                                            </span>
                                                          </TableCell>
                                                        </TableRow>
                                                      )}
                                                    {item.addiotinalDetails
                                                      .autoRenewable && (
                                                        <TableRow>
                                                          <TableCell>
                                                            <span
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                gap: "1rem",
                                                                paddingLeft:
                                                                  "40px",
                                                              }}
                                                            >
                                                              <EnterArrow />
                                                              {/* {t('RENEWAL_STATUS')} :  */}
                                                              {t("AUTO_RENEWAL")}{" "}
                                                              :{" "}
                                                              {item
                                                                .addiotinalDetails
                                                                .autoRenewable ===
                                                                "Y"
                                                                ? t("YES")
                                                                : t("NO")}
                                                            </span>
                                                          </TableCell>
                                                        </TableRow>
                                                      )}
                                                    {item.addiotinalDetails
                                                      .contractPeriod && (
                                                        <TableRow>
                                                          <TableCell>
                                                            <span
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                gap: "1rem",
                                                                paddingLeft:
                                                                  "40px",
                                                              }}
                                                            >
                                                              <EnterArrow />
                                                              {t(
                                                                "CONTRACT_PERIOD",
                                                              )}{" "}
                                                              :{" "}
                                                              {
                                                                item
                                                                  .addiotinalDetails
                                                                  .contractPeriod
                                                              }{" "}
                                                              {t("MONTHS")}
                                                            </span>
                                                          </TableCell>
                                                        </TableRow>
                                                      )}
                                                  </>
                                                )}
                                              {item.additionalAttributes &&
                                                item.additionalAttributes.map(
                                                  (component, c) =>
                                                    component.namedType ===
                                                    "params" && (
                                                      <React.Fragment key={c}>
                                                        {component.namedId &&
                                                          JSON.parse(
                                                            component.namedId,
                                                          ).length > 0 && (
                                                            <>
                                                              {/* <TableRow>
                                                                                            {(c == 0) &&
                                                                                                <>
                                                                                                    {JSON.parse(component.namedId).map((param, p) =>
                                                                                                        <TableCell key={p}><b>{param.label} : {param.value}</b></TableCell>
                                                                                                    )}
                                                                                                </>
                                                                                            }
                                                                                        </TableRow> */}
                                                              <>
                                                                {JSON.parse(
                                                                  component.namedId,
                                                                ).map(
                                                                  (
                                                                    param,
                                                                    p,
                                                                  ) => (
                                                                    <TableRow>
                                                                      <TableCell
                                                                        key={p}
                                                                      >
                                                                        <span
                                                                          style={{
                                                                            display:
                                                                              "flex",
                                                                            alignItems:
                                                                              "center",
                                                                            gap: "1rem",
                                                                            paddingLeft:
                                                                              "40px",
                                                                          }}
                                                                        >
                                                                          <EnterArrow />
                                                                          {
                                                                            param.label
                                                                          }{" "}
                                                                          :{" "}
                                                                          {
                                                                            param.value
                                                                          }
                                                                        </span>
                                                                      </TableCell>
                                                                    </TableRow>
                                                                  ),
                                                                )}
                                                              </>
                                                            </>
                                                          )}
                                                      </React.Fragment>
                                                    ),
                                                )}
                                              {item.addiotinalDetails &&
                                                item.addiotinalDetails
                                                  .subscriptionId && (
                                                  <>
                                                    {item.addiotinalDetails
                                                      .history &&
                                                      item.addiotinalDetails
                                                        .history.length > 0 && (
                                                        <TableRow>
                                                          <TableCell>
                                                            <span
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                gap: "1rem",
                                                                paddingLeft:
                                                                  "40px",
                                                              }}
                                                            >
                                                              <EnterArrow />
                                                              {t("HISTORY")} :
                                                            </span>
                                                            <div
                                                              style={{
                                                                paddingLeft: 80,
                                                              }}
                                                            >
                                                              <Card
                                                                className="roundCorners"
                                                                variant="outlined"
                                                              >
                                                                <TableContainer>
                                                                  <Table
                                                                    className={
                                                                      "subscriptionTable"
                                                                    }
                                                                  >
                                                                    <TableHead>
                                                                      <TableRow>
                                                                        <TableCell>
                                                                          {t(
                                                                            "DATE",
                                                                          )}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                          {t(
                                                                            "STATUS",
                                                                          )}
                                                                        </TableCell>
                                                                      </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                      {item.addiotinalDetails.history.map(
                                                                        (
                                                                          historyItem,
                                                                          h,
                                                                        ) => (
                                                                          <TableRow
                                                                            key={
                                                                              h
                                                                            }
                                                                          >
                                                                            <TableCell>
                                                                              {formatDate(
                                                                                historyItem.date,
                                                                              )}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                              {/* {historyItem.status} */}
                                                                              <Chip
                                                                                size="normal"
                                                                                className={
                                                                                  historyItem.status ===
                                                                                    "Active"
                                                                                    ? "successChip"
                                                                                    : historyItem.status ===
                                                                                      "Termination in Progress"
                                                                                      ? "errorChip"
                                                                                      : "inProgressChip"
                                                                                }
                                                                                label={
                                                                                  historyItem.status
                                                                                }
                                                                              />
                                                                            </TableCell>
                                                                          </TableRow>
                                                                        ),
                                                                      )}
                                                                    </TableBody>
                                                                  </Table>
                                                                </TableContainer>
                                                              </Card>
                                                            </div>
                                                          </TableCell>
                                                        </TableRow>
                                                      )}
                                                    {item.addiotinalDetails
                                                      .invoices &&
                                                      item.addiotinalDetails
                                                        .invoices.length >
                                                      0 && (
                                                        <TableRow>
                                                          <TableCell>
                                                            <span
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                gap: "1rem",
                                                                paddingLeft:
                                                                  "40px",
                                                              }}
                                                            >
                                                              <EnterArrow />
                                                              {t(
                                                                "INVOICE_HISTORY",
                                                              )}{" "}
                                                              :
                                                            </span>
                                                            <div
                                                              style={{
                                                                paddingLeft: 80,
                                                              }}
                                                            >
                                                              <Card
                                                                className="roundCorners"
                                                                variant="outlined"
                                                              >
                                                                <TableContainer>
                                                                  <Table
                                                                    className={
                                                                      "subscriptionTable"
                                                                    }
                                                                  >
                                                                    <TableHead>
                                                                      <TableRow>
                                                                        <TableCell>
                                                                          {t(
                                                                            "INVOICE_NO",
                                                                          )}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                          {t(
                                                                            "DATE",
                                                                          )}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                          {t(
                                                                            "STATUS",
                                                                          )}
                                                                        </TableCell>
                                                                      </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                      {item.addiotinalDetails.invoices.map(
                                                                        (
                                                                          invoiceItem,
                                                                          h,
                                                                        ) => (
                                                                          <TableRow
                                                                            key={
                                                                              h
                                                                            }
                                                                          >
                                                                            <TableCell>
                                                                              {
                                                                                invoiceItem.invoiceId
                                                                              }
                                                                            </TableCell>
                                                                            <TableCell>
                                                                              {formatDate(
                                                                                invoiceItem.invoiceDate,
                                                                              )}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                              {/* {invoiceItem.status} */}
                                                                              <Chip
                                                                                size="normal"
                                                                                className={
                                                                                  invoiceItem.status ===
                                                                                    "Paid"
                                                                                    ? "successChip"
                                                                                    : "inProgressChip"
                                                                                }
                                                                                label={
                                                                                  invoiceItem.status
                                                                                }
                                                                              />
                                                                            </TableCell>
                                                                          </TableRow>
                                                                        ),
                                                                      )}
                                                                    </TableBody>
                                                                  </Table>
                                                                </TableContainer>
                                                              </Card>
                                                            </div>
                                                          </TableCell>
                                                        </TableRow>
                                                      )}
                                                  </>
                                                )}
                                            </TableBody>
                                          </Table>
                                        </TableContainer>
                                      )}
                                    </div>
                                  </Collapse>
                                </TableCell>
                              </TableRow>
                            </>
                          ) : null,
                        )}
                      {props.subscriptions &&
                        props.subscriptions.length === 0 &&
                        !props.searchingSubscriptions && (
                          <TableRow>
                            <TableCell colSpan={6} align="center">
                              {t("SUBSCRIPTION_NOT_FOUND")}
                            </TableCell>
                          </TableRow>
                        )}
                      {props.searchingSubscriptions && (
                        <TableRow>
                          <TableCell colSpan={6} align="center">
                            {t("SEARCHING")}
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                {props.totalSubscriptionCount > 0 && (
                  <div
                    className="global-custom-pagination"
                    style={{ background: "rgba(196, 196, 196, 0.2)" }}
                  >
                    <label style={{ float: "left", padding: "5px" }}>
                      {props.t("TOTAL_RECORDS")}: {props.totalSubscriptionCount}
                    </label>
                    <label>
                      {/* Rows per page select */}
                      {t("ROWS_PER_PAGE")}:
                      <Select
                        value={props.subsHistoryPerPage}
                        onChange={props.updateSubsHistoryPerPageRows}
                      >
                        <MenuItem
                          value={10}
                          classes={{ root: "treeRowPerPageItem" }}
                        >
                          10
                        </MenuItem>
                        <MenuItem
                          value={50}
                          classes={{ root: "treeRowPerPageItem" }}
                        >
                          50
                        </MenuItem>
                        <MenuItem
                          value={100}
                          classes={{ root: "treeRowPerPageItem" }}
                        >
                          100
                        </MenuItem>
                      </Select>
                    </label>
                    {/* Pagination component */}
                    <Pagination
                      page={props.subsHistoryPage}
                      count={Math.ceil(
                        props.totalSubscriptionCount / props.subsHistoryPerPage,
                      )}
                      onChange={props.onSubsHistoryPageChange}
                      showFirstButton
                      showLastButton
                    />
                  </div>
                )}
                {/* </Paper> */}
              </Card>
            </div>
          </Grid>
        </Grid>

        {/* Cancel LTE subscription dialog */}
        <CancelDialog
          isOpen={cancelData.open}
          close={closeCancelDialog}
          cancelData={cancelData}
        />
        <AddonDialog
          isOpen={addonData.open}
          close={closeAddAddonDialog}
          data={addonData}
        />
        <ChangeDialog
          isOpen={changeData.open}
          close={closeChangeDialog}
          data={changeData}
        />

        <AddonDialog
          isOpen={addonData.open}
          close={closeAddAddonDialog}
          data={addonData}
        />

        {/* Update LTE devices dialog */}
        <UpdateDialog
          isOpen={updateData.open}
          close={closeUpdateDialog}
          data={updateData}

        // solutionPlans={this.state.solutionPlans}
        // serviceInstanceId={this.state.selectedServiceInstanceId}
        // updateSubscription={this.updateSubscription}
        // details={this.state.details}
        // selectedPlan={this.state.selectedPlan}
        // firstLevelFeatureId={this.state.selectedFirstLevelFeatureId}

        // availableVariants={this.state.availableVariants}
        />

        {/* Suspend/Resume subscription dialog */}
        <SuspendDialog
          isOpen={suspendData.open}
          close={closeSuspendDialog}
          action={suspendData.action}
          months={suspendData.months}
          onChangeMonths={onChangeMonths}
        />

        {showCustomerDialog && (
          <Dialog
            disableScrollLock={true}
            maxWidth={"lg"}
            // PaperComponent={DraggableDialogPaper}
            PaperComponent={DraggableResizablePaper}
            fullWidth={true}
            open={showCustomerDialog}
            aria-labelledby="import-dialog-title"
          // PaperProps={{
          //     className: classess.resizablePaper
          // }}
          >
            <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
              {t("SELECT_CUSTOMER")}
              {props.providerType === "SALES_CHNL_PROVIDER" &&
                (props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                  props.loggedInUserType !== "ECOMMERCE_ADMIN") && (
                  <Button
                    style={{ float: "right" }}
                    onClick={() => {
                      setShowCustomerDialog(false);
                      setShowNewCustomer(true);
                    }}
                  >
                    {t("ADD_CUSTOMER")}
                  </Button>
                )}
            </DialogTitle>
            <DialogContent dividers style={{ height: "550px" }}>
              <ManageCustomersHierarchy
                screen="checkout"
                subScreen="product"
                stage={0}
                next={selectCustomerClose}
                // back={this.back}
                selectedTreeItems={selectedTreeItems}
                customerDetails={customerDetails}
                selectedPaymentMethod={selectedPaymentMethod}
                resetSelecteddata={resetSelecteddata}
                closeDialog={closeDialog}
              // parentTenantId={this.state.parentTenantId}

              // offeringCustomer={(this.props.ecommerceCustData && this.props.ecommerceCustData.partyId) ? this.props.ecommerceCustData.partyId : this.state.offeringCustomer}
              // offeringCustomer={(this.props.ecommerceCustData && this.props.ecommerceCustData.partyId) ? [this.props.ecommerceCustData.partyId] : this.state.offeringCustomersList}
              />
            </DialogContent>
          </Dialog>
        )}

        {showNewCustomer && (
          <Dialog
            disableScrollLock={true}
            maxWidth={"lg"}
            // PaperComponent={DraggableDialogPaper}
            PaperComponent={DraggableResizablePaper}
            fullWidth={true}
            open={showNewCustomer}
            aria-labelledby="import-dialog-title"
          >
            <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
              {t("ADD_NEW_CUSTOMER")}
            </DialogTitle>
            <DialogContent dividers>
              <CustomerDetails
                manageCustomer={true}
                close={removeCustomerForm}
                addCustomer={addCustomer}
                validator={closeErrorMessage}
                customerDetails={newCustomerDetails}
              />
            </DialogContent>
          </Dialog>
        )}
      </div>
      <Loader loading={loading} />
    </div>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

const mapStateToProps = (state) => {
  return {
    providerType: state.auth.providerType,
    userPerms: state.auth.userPerms,
    loggedInUserType: state.auth.userLoginType,
    quoteEnabled: state.auth.quoteEnabled,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(SubscriptionsTable));
